/** Exactly one programmatic ad provider at a time. */
// Controlled AdSense recovery test. Only the single base inline placement is enabled.
// This deliberately overrides NEXT_PUBLIC_AD_PROVIDER, including a stale "journey" value.
export const AD_PROVIDER = "adsense-inline-only" as const;
export const ADSENSE_INLINE_ONLY = true;
export const NITRO_ENABLED = false;
export const ADSTERRA_ENABLED = false;
export const GOOGLE_ADS_ENABLED = false; // Keeps legacy GAM/AdSlot integrations disabled.
export const NITRO_SCRIPT_URL = "https://s.nitropay.com/ads-2684.js";
export const NITRO_MOBILE_PLACEMENT_ID = "bfc_base_inline_1";

export const JOURNEY_ENABLED = false;
export const JOURNEY_SCRIPT_URL = "https://scripts.scriptwrapper.com/tags/304645f1-5371-49f5-b7e3-3f2990bb3766.js";
